import { makeAutoObservable } from 'mobx';
import {fullName, dateFormatter} from 'shared/tools';
import _ from 'lodash';

class CandidateViewModel {
  candidate;
  selected = false;
  stateChanged = false;
  active = false;

  constructor(candidate) {
    makeAutoObservable(this);

    this.candidate = candidate;
  }

  get name() {
    return fullName(this.candidate);
  }

  get originDate() {
    return dateFormatter(this.candidate.createdAt);
  }

  get currentStageDate() {
    return dateFormatter(this.candidate.enteredCurrentStageAt) || dateFormatter(this.candidate.createdAt);
  }

  get currentStageName() {
    return this.candidate.currentStage.name;
  }

  get backgroundInformationVisible() {
    return this.candidate.additionalInformation
      || this.candidate.resume
      || !_.isEmpty(this.candidate.answers);
  }
}

export default CandidateViewModel;
